export enum RemoteDataState {
  NotFetched = 'notFetched',
  Loading = 'loading',
  Error = 'error',
  Loaded = 'loaded',
}

export interface RemoteDataNotFetched {
  kind: RemoteDataState.NotFetched;
}

export interface RemoteDataLoading {
  kind: RemoteDataState.Loading;
}

export interface RemoteDataLoaded<T = unknown> {
  kind: RemoteDataState.Loaded;
  data: T;
}

export interface RemoteDataError {
  kind: RemoteDataState.Error;
  error: Error;
}

export type RemoteData<T = unknown> =
  | RemoteDataNotFetched
  | RemoteDataLoading
  | RemoteDataLoaded<T>
  | RemoteDataError;

export function isRemoteDataLoaded(
  remoteData: RemoteData
): remoteData is RemoteDataLoaded {
  return remoteData.kind === RemoteDataState.Loaded;
}

export function isRemoteDataError(
  remoteData: RemoteData
): remoteData is RemoteDataError {
  return remoteData.kind === RemoteDataState.Error;
}

export function isRemoteDataLoading(
  remoteData: RemoteData
): remoteData is RemoteDataLoading {
  return remoteData.kind === RemoteDataState.Loading;
}

export function isRemoteDataNotFetched(
  remoteData: RemoteData
): remoteData is RemoteDataNotFetched {
  return remoteData.kind === RemoteDataState.NotFetched;
}

export function remoteDataLoading(): RemoteDataLoading {
  return {
    kind: RemoteDataState.Loading,
  };
}

export function remoteDataNotFetched(): RemoteDataNotFetched {
  return {
    kind: RemoteDataState.NotFetched,
  };
}

export function remoteDataLoaded<T>(data: T): RemoteDataLoaded<T> {
  return {
    kind: RemoteDataState.Loaded,
    data,
  };
}

export function remoteDataError(error: Error): RemoteDataError {
  return {
    kind: RemoteDataState.Error,
    error,
  };
}
